// @flow
import { setName } from 'pages/Slices/packetSlice'
import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Space from 'ui/atoms/Space'
import PageTitleInput from 'ui/molecules/PageTitleInput'

import PacketBuilder from './Components/PacketBuilder'

function PacketDetails(): React.Node {
  const dispatch = useDispatch()
  const { name, errors } = useSelector((state) => state.packet)
  const onChange = React.useCallback(
    (event) => {
      dispatch(setName(event.currentTarget.value))
    },
    [dispatch]
  )
  return (
    <Space size="large">
      <PageTitleInput
        error={errors?.name}
        onChange={onChange}
        value={name || ''}
      />
      <PacketBuilder />
    </Space>
  )
}

export default PacketDetails
